import React, { Component } from "react";
import MapModal from './../components/MapModal';

let googleMapsScriptLoaded = false;

class GoogleMap extends Component {
	constructor(props) {
        super(props);

        this.state = {
			map: null,
      		markers: [],
			showModal: false,
			jobDetails: "",
			isJobDetail: this.props.isJobDetail || false,
        };

		this.mapRef = React.createRef();
		this.searchMarker = null; // 
    }

	componentDidMount() {
		this.loadGoogleMapsScript();
	}

	componentWillUnmount() {
		this.state.markers.forEach(marker => {
			if (marker.infoWindow) {
				marker.infoWindow.close();
			}
			marker.setMap(null);
		});

		// ✅ Clean search marker
		if (this.searchMarker) {
			this.searchMarker.setMap(null);
		}
	}

	loadGoogleMapsScript() {
		if (googleMapsScriptLoaded) {
			this.initMap();
			return;
		}

		googleMapsScriptLoaded = true;
		this.initMap();
		window.initMap = this.initMap;
	}

	initMap = () => {
		let mapInstance = new window.google.maps.Map(this.mapRef.current, {
			center: { lat: 47.6061, lng: -122.60321 },
			zoom: 8,
			mapTypeControl: false,
			streetViewControl: false,
		});

		//  After map ready → init search (if provided)
		this.setState({ map: mapInstance }, () => {
			setTimeout(() => {
				this.initAutocomplete();
			}, 300); // important delay
		});
	};

	//  NEW: Autocomplete support (optional)
	initAutocomplete = () => {
		if (!window.google || !window.google.maps.places) return;

		const google = window.google;

		const input = typeof this.props.searchInput === "function"
			? this.props.searchInput()
			: this.props.searchInput;

		if (!input) return;

		const autocomplete = new google.maps.places.Autocomplete(input);

		autocomplete.addListener("place_changed", () => {
			const place = autocomplete.getPlace();
			if (!place.geometry) return;

			const location = place.geometry.location;

			// Move map
			this.state.map.panTo(location);
			this.state.map.setZoom(14);

			// Remove old search marker
			// if (this.searchMarker) {
			// 	this.searchMarker.setMap(null);
			// }

			// // Add blue marker
			// this.searchMarker = new google.maps.Marker({
			// 	position: location,
			// 	map: this.state.map,
			// 	title: place.formatted_address,
			// 	icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
			// });
		});
	};

	resetMap = () => {
		if (!this.state.map) return;

		const defaultCenter = { lat: 47.6061, lng: -122.60321 };

		// Reset center & zoom
		this.state.map.setCenter(defaultCenter);
		this.state.map.setZoom(8);

		// Remove search marker
		if (this.searchMarker) {
			this.searchMarker.setMap(null);
			this.searchMarker = null;
		}
	};

	geocodeLatLng(lat, lng, title, jobData) {
		const google = window.google;

		const location = new google.maps.LatLng(lat, lng);
		this.addMarker(location, title, jobData);
		this.state.map.setCenter(location);
	}

	addMarker(location, title, jobData) {
		const google = window.google;
		const marker = new google.maps.Marker({
			position: location,
			map: this.state.map,
			title: title ? String(title) : "",
		});

		marker.addListener("click", () => {
			this.openModal(jobData);
		});

		this.setState((prevState) => ({
			markers: [...prevState.markers, marker],
		}));
	}

	markerInitiated() {
		if (this.state.markers && this.state.markers.length) {
			this.state.markers.forEach((marker) => {
				marker.setMap(null);
			});
		}

		this.setState({ markers: [] }, () => {
			if (this.props.dataList && this.props.dataList.length) {
				this.props.dataList.forEach((element) => {
					this.addMarker(
						{ lat: element.latitude, lng: element.longitude },
						`Total Jobs - ${element.count}`,
						element.jobList
					);
				});
			}
		});
	}

	openModal = (jobData) => {
		this.setState({ showModal: true, jobDetails: jobData }, () => {
			window.openModal('mapModal');
		});
	};

	closeModal = () => {
		this.setState({ showModal: false, jobDetails: null });
	};

	render() {
		const { showModal, jobDetails, isJobDetail } = this.state;

		return (
			<div className="row">
				<div className="col-12">
					<div ref={this.mapRef} id="googleMapSection" className='w-100 h-500'></div>
				</div>

				{showModal && !isJobDetail && jobDetails && jobDetails.length && (
					<MapModal jobDetails={jobDetails} closeModal={this.closeModal} />
				)}
			</div>
		);
	}
}

export default GoogleMap;